<template>
  <div class="notification-stack">
    <TransitionGroup name="notif" tag="div" class="notification-stack__list">
      <div
        v-for="n in store.visible"
        :key="n.id"
        class="notification-card"
        :class="`notification-card--${n.icon}`"
      >
        <i class="pi notification-icon" :class="iconClass(n.icon)"></i>
        <div class="notification-body">
          <div class="notification-title">{{ n.title }}</div>
          <div v-if="n.text" class="notification-text">{{ n.text }}</div>
        </div>
        <button type="button" class="notification-close" aria-label="إغلاق" @click="store.dismiss(n.id)">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
import { useNotificationStore } from '@/stores/useNotificationStore.js';

const ICONS = {
  success: 'pi-check-circle',
  warning: 'pi-exclamation-triangle',
  error:   'pi-times-circle',
  info:    'pi-info-circle',
};

export default {
  name: 'NotificationStack',

  setup() {
    return { store: useNotificationStore() };
  },

  methods: {
    iconClass(type) {
      return ICONS[type] || ICONS.info;
    },
  },
};
</script>

<style scoped>
.notification-stack {
  position: fixed;
  top: 76px;
  right: 16px;
  z-index: 2000;
  width: 320px;
  max-width: calc(100vw - 32px);
  pointer-events: none;
}

.notification-stack__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.notification-card {
  pointer-events: auto;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  background: #fff;
  border-radius: 10px;
  border-left: 4px solid #6c757d;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
  padding: 12px 14px;
}

.notification-card--success { border-left-color: #28a745; }
.notification-card--warning { border-left-color: #ffc107; }
.notification-card--error   { border-left-color: #dc3545; }
.notification-card--info    { border-left-color: #0dcaf0; }

.notification-icon {
  font-size: 1.3rem;
  line-height: 1;
  margin-top: 2px;
  flex-shrink: 0;
}
.notification-card--success .notification-icon { color: #28a745; }
.notification-card--warning .notification-icon { color: #ffc107; }
.notification-card--error   .notification-icon { color: #dc3545; }
.notification-card--info    .notification-icon { color: #0dcaf0; }

.notification-body {
  flex: 1;
  min-width: 0;
  text-align: right;
}
.notification-title {
  font-weight: 700;
  font-size: 0.92rem;
  color: #212529;
}
.notification-text {
  font-size: 0.82rem;
  color: #495057;
  margin-top: 2px;
}

.notification-close {
  background: none;
  border: none;
  color: #adb5bd;
  cursor: pointer;
  padding: 0;
  font-size: 0.85rem;
  line-height: 1;
  flex-shrink: 0;
}
.notification-close:hover { color: #495057; }

/* ── Enter/leave animation ── */
.notif-enter-active,
.notif-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.notif-enter-from {
  opacity: 0;
  transform: translateY(-12px);
}
.notif-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.notif-leave-active {
  position: absolute;
}
.notif-move {
  transition: transform 0.25s ease;
}
</style>
